import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { failureBulletText } from '../utils';
import { FAILURE_PANEL_TITLE, SUCCESS_PANEL_TITLE, SUCCESS_READY_MESSAGE } from './constants';
import {
  FailureCard,
  FailureIcon,
  FailureItem,
  FailureList,
  PanelFooter,
  PanelTitle,
  SuccessCard,
  SuccessIcon,
  SuccessItem,
  SuccessList,
} from './styled';
import { ValidationResultProps } from './types';

const ValidationResult = ({ failures, retry, successLines }: ValidationResultProps) => {
  if (successLines.length > 0) {
    return (
      <SuccessCard data-testid="validation-summary">
        <PanelTitle>{SUCCESS_PANEL_TITLE}</PanelTitle>
        <SuccessList>
          {successLines.map((line) => (
            <SuccessItem key={line}>
              <SuccessIcon>
                <CheckCircleIcon fontSize="inherit" />
              </SuccessIcon>
              <span>{line}</span>
            </SuccessItem>
          ))}
        </SuccessList>
        <PanelFooter>{SUCCESS_READY_MESSAGE}</PanelFooter>
      </SuccessCard>
    );
  }

  if (failures.length === 0 && !retry) return null;

  return (
    <FailureCard>
      <PanelTitle>{FAILURE_PANEL_TITLE}</PanelTitle>
      <FailureList>
        {failures.map((failure) => (
          <FailureItem key={failure.code} data-testid="validation-failure">
            <FailureIcon>
              <CancelIcon fontSize="inherit" />
            </FailureIcon>
            <span>{failureBulletText(failure)}</span>
          </FailureItem>
        ))}
        {retry && (
          <FailureItem data-testid="validation-retry">
            <FailureIcon>
              <CancelIcon fontSize="inherit" />
            </FailureIcon>
            <span>{retry}</span>
          </FailureItem>
        )}
      </FailureList>
    </FailureCard>
  );
};

export default ValidationResult;
